// extracted by mini-css-extract-plugin
export var formats = "formats-module--formats--pCD0o";
export var formats__container = "formats-module--formats__container--uB7Hl";
export var formats__itemTitle = "formats-module--formats__item-title--C90ym";
export var formats__itemDesc = "formats-module--formats__item-desc--rGpu+";
export var formats__item = "formats-module--formats__item--PC3g-";